var map = {
	"./anonymous.svg": "a979",
	"./dan_syrotynskyy.jpg": "2221",
	"./ivan_danyliuk.png": "7e8f",
	"./mykhailo_pustovit.jpg": "f99c",
	"./nick_urs.png": "4253",
	"./sergiy_mokienko.jpg": "4143",
	"./serhii_myskiv.jpg": "734d"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "cad3";